"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statuses = void 0;
exports.statuses = {
    AVAILABLE_NOW_STATUS: 'available_now',
    BACKORDERED_STATUS: 'backordered',
    DELAYED_SHIPPING_STATUS: 'delayedshipping',
    UNAVAILABLE_STATUS: 'unavailable',
    COMING_SOON_STATUS: 'coming_soon',
    BY_PREORDER_STATUS: 'by_preorder',
    SOLD_OUT_STATUS: 'sold_out',
};
exports.default = exports.statuses;
